import styled from "styled-components";

export default styled.input`
    background: transparent;
    border: 1px solid #0002;
    border-radius: 4px;
    outline: none transparent;
    padding: 8px;
    transition: 200ms outline-color;

    &:focus {
        outline: 2px solid royalblue;
        outline-offset: -1px;
    }

    &::placeholder {
        color: #0005;
    }
`;
